<template>
	<!-- 滑块验证码 -->
	<div ref="big" :class="confirmSuccess ? 'big big-ok' : 'big'">
		<div class="text">{{ confirmWords }}</div>
		<div class="bg" :style="'width:' + bgwidth + 'px;'">
			<div class="text">{{ confirmWords }}</div>
		</div>
		<div ref="hand" v-drag="{ set: dragFn, distance: distance, confirmSuccess: confirmSuccess, sliderCodeable: sliderCodeable }" :class="confirmSuccess ? 'hand handlerFinish' : 'hand handler'">
			<div class="arrow-right"></div>
			<div class="icon-success"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SliderCode',
	data() {
		return {
			bgwidth: 0, // 背景色块当前位置
			confirmWords: '按住滑块, 拖动至最右', // 滑块文字
			confirmSuccess: false, // 是否成功
			distance: 0,
			handWidth: 0,
			sliderCodeable: true
		};
	},
	props: {},
	created() {},
	mounted() {
		this.getElementWidth();
	},
	watch: {},
	methods: {
		getElementWidth() {
			// 使用 $refs 获取元素的引用
			const big = this.$refs.big;
			const hand = this.$refs.hand;
			this.handWidth = hand.offsetWidth;
			// 获取元素的宽度
			this.distance = big.offsetWidth - this.handWidth;
			console.log('this.distance: ', this.distance);
		},
		// 自定义组件引用的方法
		dragFn(x) {
			this.bgwidth = x + this.handWidth;
			if (x == this.distance) {
				this.confirmWords = '验证通过';
				this.confirmSuccess = true;
				this.$emit('confirmSuccessBool', this.confirmSuccess);
			}
		},
		/** 重置滑块（票据过期或发送失败后需重新拖动） */
		reset() {
			this.bgwidth = 0;
			this.confirmWords = '按住滑块, 拖动至最右';
			this.confirmSuccess = false;
			this.$nextTick(() => {
				if (this.$refs.hand) {
					this.$refs.hand.style.left = '0px';
				}
				this.getElementWidth();
			});
			this.$emit('confirmSuccessBool', false);
		}
	},
	//注册局部组件指令
	directives: {
		drag: (el, bindings) => {
			let dragBox = el;
			let left = 0;
			dragBox.onmousedown = (e) => {
				if (!bindings.value.sliderCodeable) {
					return;
				}
				//算出鼠标相对元素的位置
				let disX = e.clientX - dragBox.offsetLeft;
				document.onmousemove = (e) => {
					if (bindings.value.confirmSuccess) {
						return;
					}
					if (!bindings.value.sliderCodeable) {
						return;
					}
					//用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
					left = e.clientX - disX;
					if (left <= 0) {
						left = 0;
					} else if (left > bindings.value.distance) {
						left = bindings.value.distance;
						//鼠标弹起来的时候不再移动
						document.onmousemove = null;
						//预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）
						document.onmouseup = null;
					}
					dragBox.style.left = left + 'px';
					// dragFn方法接收 left
					bindings.value.set(left);
				};
				document.onmouseup = (e) => {
					if (bindings.value.confirmSuccess) {
						return;
					}
					if (!bindings.value.sliderCodeable) {
						return;
					}
					//鼠标弹起来的时候不再移动
					document.onmousemove = null;
					//预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）
					document.onmouseup = null;
					if (left != bindings.value.distance) {
						left = 0;
						dragBox.style.left = left + 'px';
						// dragFn方法接收 left
						bindings.value.set(left);
					}
				};
			};
		}
	}
};
</script>

<style lang="scss" scoped>
.big {
	position: relative;
	/* background-color: #75cdf9; */
	/* width: 300px; */
	height: 34px;
	line-height: 34px;
	text-align: center;
}

.big-ok {
	color: #fff;
	background-color: #0ab4a2;
}

.hand {
	position: absolute;
	top: 0px;
	left: 0px;
	width: 34px;
	height: 34px;
	cursor: move;
	display: flex;
	justify-content: center;
	align-items: center;
	background: $primary;
}

.handler {
	// background: #fff
	// 	url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAYAAAA4E5OyAAAAAXNSR0IArs4c6QAAAetJREFUeF7t2j1IQlEcBfAjYvggl7LByZaiLwibwiiMhuSRZRnR1BhNLS3tLY1REM2NkVYk5hIFkWu0VEORTi7WYqAkUjyHIAnxDr77D47zQx4/zrnnCjqMvf0v8PMj4CDI7zQQpK4dBCFI4wOTCWFCmBClSwUrw8qwMqyMkgArw8ooBYYrw8qwMqyMkgArw8ooBYYrw8qwMv+jMqtDg0g8v6BQLiu9cKsf1nKGWBg7oQk8vL0jfHImCkULiNftRnp+DgOdHeJQtIBYsZeKog1EKopWEIko2kGkoYgAkYQiBkQKiigQCSjiQCyULsPARXRWyz1FJIgDQCJiYtrvr13cQscJfFQqrb61175fJMj2WBDrgWEUSiWMH8WRKxZtwRAJstLfh4OpSXxWqzBPz5HJ523DEAcS9PmQikbQ5nRi7fIKh49PtmKIAvF7PLhZisFrGNi9u8fmbcZ2DDEg7S4XrhcXaquSzuYQS6ag67+i2g9Va1HiMybC3fYvyl8R1A6ic1HEgeheFFEgEhZFDIiURREDsjESwFZwVPuiiAGxXmS5twfJ16xtv1GavdRoX5lmX9Su5whSJ00QgjQuHxPChDAhSgPFyrAyrAwroyTAyrAySoHhyrAyrAwroyTAyrAySoHhyrAyjQPzDVJ1V1iv71nCAAAAAElFTkSuQmCC')
	// 	no-repeat center;
	.arrow-right {
		display: block;
	}
}

.handlerFinish {
	// background: #fff
	// 	url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAYAAAA4E5OyAAAAAXNSR0IArs4c6QAAAetJREFUeF7t2j1IQlEcBfAjYvggl7LByZaiLwibwiiMhuSRZRnR1BhNLS3tLY1REM2NkVYk5hIFkWu0VEORTi7WYqAkUjyHIAnxDr77D47zQx4/zrnnCjqMvf0v8PMj4CDI7zQQpK4dBCFI4wOTCWFCmBClSwUrw8qwMqyMkgArw8ooBYYrw8qwMqyMkgArw8ooBYYrw8qwMv+jMqtDg0g8v6BQLiu9cKsf1nKGWBg7oQk8vL0jfHImCkULiNftRnp+DgOdHeJQtIBYsZeKog1EKopWEIko2kGkoYgAkYQiBkQKiigQCSjiQCyULsPARXRWyz1FJIgDQCJiYtrvr13cQscJfFQqrb61175fJMj2WBDrgWEUSiWMH8WRKxZtwRAJstLfh4OpSXxWqzBPz5HJ523DEAcS9PmQikbQ5nRi7fIKh49PtmKIAvF7PLhZisFrGNi9u8fmbcZ2DDEg7S4XrhcXaquSzuYQS6ag67+i2g9Va1HiMybC3fYvyl8R1A6ic1HEgeheFFEgEhZFDIiURREDsjESwFZwVPuiiAGxXmS5twfJ16xtv1GavdRoX5lmX9Su5whSJ00QgjQuHxPChDAhSgPFyrAyrAwroyTAyrAySoHhyrAyrAwroyTAyrAySoHhyrAyjQPzDVJ1V1iv71nCAAAAAElFTkSuQmCC')
	// 	no-repeat center;
	.icon-success {
		display: block;
	}
}

.arrow-right {
	display: none;
	background: transparent
		url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAYAAAA4E5OyAAAAAXNSR0IArs4c6QAAAetJREFUeF7t2j1IQlEcBfAjYvggl7LByZaiLwibwiiMhuSRZRnR1BhNLS3tLY1REM2NkVYk5hIFkWu0VEORTi7WYqAkUjyHIAnxDr77D47zQx4/zrnnCjqMvf0v8PMj4CDI7zQQpK4dBCFI4wOTCWFCmBClSwUrw8qwMqyMkgArw8ooBYYrw8qwMqyMkgArw8ooBYYrw8qwMv+jMqtDg0g8v6BQLiu9cKsf1nKGWBg7oQk8vL0jfHImCkULiNftRnp+DgOdHeJQtIBYsZeKog1EKopWEIko2kGkoYgAkYQiBkQKiigQCSjiQCyULsPARXRWyz1FJIgDQCJiYtrvr13cQscJfFQqrb61175fJMj2WBDrgWEUSiWMH8WRKxZtwRAJstLfh4OpSXxWqzBPz5HJ523DEAcS9PmQikbQ5nRi7fIKh49PtmKIAvF7PLhZisFrGNi9u8fmbcZ2DDEg7S4XrhcXaquSzuYQS6ag67+i2g9Va1HiMybC3fYvyl8R1A6ic1HEgeheFFEgEhZFDIiURREDsjESwFZwVPuiiAGxXmS5twfJ16xtv1GavdRoX5lmX9Su5whSJ00QgjQuHxPChDAhSgPFyrAyrAwroyTAyrAySoHhyrAyrAwroyTAyrAySoHhyrAyjQPzDVJ1V1iv71nCAAAAAElFTkSuQmCC')
		no-repeat center;
	background-size: 100% 100%;
	width: 100%;
	height: 100%;
}

.icon-success {
	display: none;
	background: transparent
		url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAYAAAA4E5OyAAAAAXNSR0IArs4c6QAAA/tJREFUeF7tmVtIFGEUx/82WrkZFJRpbluW1lOldBUjKm/rhej2kkWW3ageopeiC+RLCUJUBEKSoZZ2tcSITF3L0oxKVzMq8xZhKBpUpIZruxvf4ErquPuNzqwbnA/2YXbO9813fnP+55yZcfO8lGoFjX4CbgRkYDQQkEHqICAExH7CpAihCKEIkdVUkGRIMiQZkowsAiQZkoysgKEqQ5IhyZBkZBEgyZBkZAXMmFQZNwArfX2wfq4/gqdPh++kSeKPjdauLvFn7OhAflMzXra2wZkvfZ0KZIIg4OCihTgcvBjeGg3XnWvv7sZFYw1S39aix2zmmjMaI6cB2TBvLlJWhUI72WtE+2351YmjZeXIa2wa0XzeSU4BcnrFchxbtoR3T3btUt5UIunlK0XWklpEdSBZURHYEhigqAN36xuw43GRomvaFlMVSNLK5Ti6VJnIGOy9WpGiGhCWM3Kio1S5i7ZF4x89VjynqAKEVZPa7fEjTqC8FFmiXXg9R9HqowqQI8FBOBMawuvXqOxOllfgvLF6VGv8O1lxIKzpak5M4O4zHHliMpuR/LoSEwVBslKxPsX/aqZizZviQEJ8fWDYvNGRn1zne81mxBcU4mHzZ9H+y+6dmObpOWRuWO59VLS2ca3pyEhxIMmhITgcHOToug7PMxjbCwrxoA/G1gXzkR4RJjnvorEax8srHK7JY6A4kIIN67Fa68dz7WFt/lgsYp9h60o3BcxDZmQ4hHHjJOc8a/kKfV7+qK6pWh9Ss20rAqdOkdzcsbJy9Pwx42xoCDQeHpI2ZosFCYXFuNfQKJ5n5Zs1d+7DwGA29d9/YHH2DdcE0r5vD7zGD3X22+/f0KVniJte7TcT9+JihkBhMHYVGcA6UTbY0/C1qAh4CIJdZztNvfBOu/J/AWG7PVL6HJdr34kbX6P1Q25cDDzd3cVji9WKxCIDbn+qF49j/ecgRx/pEAaz/WUyYUZaumsCsScZq9WKQ09KkfH+g7j5dbO0uBsbjfGCgL3FJbhR90n8Xz9bh5sxevF/nuHSknGUVBmUAyVPkfXho+hruG4WZmg0yP5YJx5H6nS4FasH63Z5h0snVZ6yy+Sx3/CkH4LNcQbnTmy0LBhs7oWqapx44aJll7cxY1D2FBlwsy9nrNVqkRsXjYl9OYU3OpidSzdmclp3VlXOVRnxs8eEUyuW9SdYOTBcvnUXqwk93A28p/T4LxHj9IJIAgq9QpSAQi+ZVY4UtV4u27at+OP/cCWTPlRJkKFPmcOEC33sltN6jrGt03LIGPvJfXkCMggVASEg9tVDEUIRQhHCXWGYIUmGJEOSIcnIIkCSIcnIChiqMiQZkgxJRhaBQcZ/ASPc+1gv6FnhAAAAAElFTkSuQmCC')
		no-repeat center;
	background-size: 100% 100%;
	width: 100%;
	height: 100%;
	border-radius: 50%;
}

// .arrow-right {
// 	display: none;
// 	background: transparent
// 		url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAaCAYAAAC6nQw6AAAAAXNSR0IArs4c6QAAAQ5JREFUSEut1bEuREEYxfH/UWynQ6/WSxQKiYbEG6jolDTeQEWn5AVUQlSyW2wh0as9AJ1O4bg3mU247u5838Z9gN/MnXO+GfFPn7qO7SPgRtJbZo1fUEEugRdgK4N1oWVg1OxoLYv1/dpc2B+oPRfbaawXmgebCmWxmVAGq0JRLARFsDBUsBVg2NezLLQA3AM7pbAbkj7aRbLQOXAMvAPrkl4n8xiGbB8AV8AnsC1p/HOoQ5DtTeARGACHkq67N0MVsr0KPANLwEVzJid910ut2YvAU0npAdiT9JWCbLcJ3TW72e0mlIWmJhSGagmFoEhCVSiaUAQ6Bc6a1s5MqAqVwdwHbiczFH2SqoWMQt8ZKYob+Nu3DgAAAABJRU5ErkJggg==')
// 		no-repeat center;
// 	width: 8.27px;
// 	height: 13px;
// }

// .icon-success {
// 	display: none;
// 	background: transparent
// 		url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAlFJREFUSEu9l8urTWEYxn+POxlKKFP/gJkoQpISuZcTSUZSUhQGCqdwTkqZSbnkkvtlTikzf4AzVRQmOgZy++xne9dpWfbaa217W7vWYK/vfd/fd3m+5/uWqPFLKU0ClgAbgMXAgnic/TaeV8BD4KWkn1Vl1S0gpTQDOAAcAuZWFYv298AocEHSl7KcUnBKaRNwHlhYE1gMewMclHSvU/5f4JSS350Ejv0jsJg2DByXlPINf4ADehPYNiBoVuY2sCMPL4JPA0cHDM3KDUuamMUJcKzp3f8Ezcpuzta8DQ71jvUhpLr9teAWWe0Z+DBwpm52n3FHJJ1VmMO7HvZpFfdr7Ap7QKed4X0+3+ClwIuqajXbvwFex8exhB+AOR1ylxk8Es5Us3ZpmKFbJdk2rZsh4GpJ9KjBz4DlfVK/A9szxaaUtgD2g8kldZ8b/NpKKwmwR9tvzwGzSmJ+hDnciZHaam8BU7oMZszgcWB2h6CPFpzdJqW0AnjaAW7oTkkGeXo3AnapqRUz+Lkb2Ln7JV2MoitbR+KT1rabGUV99A1JuhHt6wEbUBXU4eNVU21j3yfpUhRfDVix04Ddkq7F+3XA/XhfRy7tqa4Sl+F7JV0OyBpgnqQr8X8t8ACYXocYMW1x1dlOntY9GSwDpJTciUc9Qp0+0ouBGL5L0vUY6apYcztUr7+2gfg+VdcyrWJ7+qcW6UROaL2Af1tm9L75QyLAnq7mj8Wc4zR7EciptPmrT4zaa978ZS8HPzXAS1/19Ta/Jxq/0BfgzX/CFDow8I+2X9rj/aOUi2LtAAAAAElFTkSuQmCC')
// 		no-repeat center;
// 	width: 15px;
// 	height: 15px;
// 	border-radius: 50%;
// }

.bg {
	background-color: #0ab4a2;
	height: 34px;
	width: 0px;
	overflow: hidden;
	.text {
		position: relative;
		// top: 0px;
		// left: 0px;
		// right: 0px;
		/* 	left: 45px; */
		padding-left: 45px;
		font-size: 12px;
		color: #fff;
		/* width: 300px; */
		-moz-user-select: none;
		-webkit-user-select: none;
		user-select: none;
		-o-user-select: none;
		-ms-user-select: none;
		box-sizing: border-box;
		text-align: left;
	}
	/* margin-left: 2px; */
	/* 取消滑块移动回弹后，因边框导致的颜色泄露 */
}

.text {
	position: absolute;
	top: 0px;
	left: 0px;
	right: 0px;
	/* 	left: 45px; */
	padding-left: 45px;
	font-size: 12px;
	color: #000000;
	/* width: 300px; */
	-moz-user-select: none;
	-webkit-user-select: none;
	user-select: none;
	-o-user-select: none;
	-ms-user-select: none;
	box-sizing: border-box;
	overflow: hidden;
	text-align: left;
}
</style>
